// extracted by mini-css-extract-plugin
export var footer = "_pr-0";
export var inherit = "_pr-1";
export var input = "_pr-2";
export var modalContent = "_pr-3";
export var quillEditor = "_pr-4";
export var subtitle = "_pr-5";